import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Status icon, enabled variant — dark traffic light with red / amber / green dots, as the
 * Custom Module field toolbar draws it (Bombiix 2026, Status · Property 1=Variant2, hover fill removed).
 * `StatusIcon` is the disabled variant. Multi-coloured by design, so the fills are baked in.
 */
const StatusActiveIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <rect x="7.53273" y="3.74074" width="4.93593" height="12.5185" rx="0.240741" fill="#3C3C3C" />
    <rect x="7.53273" y="3.74074" width="4.93593" height="12.5185" rx="0.240741" stroke="#3C3C3C" strokeWidth="0.481481" />
    <rect x="8.49609" y="4.70312" width="3.01" height="3.01" rx="1.505" fill="#FA979B" />
    <rect x="8.49609" y="8.49414" width="3.01" height="3.01" rx="1.505" fill="#FDD499" />
    <rect x="8.49609" y="12.2871" width="3.01" height="3.01" rx="1.505" fill="#73C5AF" />
    <path
      d="M12.8291 4.94387C12.8291 4.81091 12.9369 4.70312 13.0698 4.70312H14.8403C15.0448 4.70312 15.1562 4.94208 15.0246 5.09871L13.2542 7.20634C13.1097 7.37839 12.8291 7.27619 12.8291 7.0515V4.94387Z"
      fill="#3C3C3C"
    />
    <path
      d="M12.8291 8.73683C12.8291 8.60388 12.9369 8.49609 13.0698 8.49609H14.8403C15.0448 8.49609 15.1562 8.73505 15.0246 8.89168L13.2542 10.9993C13.1097 11.1714 12.8291 11.0692 12.8291 10.8445V8.73683Z"
      fill="#3C3C3C"
    />
    <path
      d="M12.8291 12.5278C12.8291 12.3949 12.9369 12.2871 13.0698 12.2871H14.8403C15.0448 12.2871 15.1562 12.5261 15.0246 12.6827L13.2542 14.7903C13.1097 14.9624 12.8291 14.8602 12.8291 14.6355V12.5278Z"
      fill="#3C3C3C"
    />
    <path
      d="M7.1709 12.5278C7.1709 12.3949 7.06312 12.2871 6.93016 12.2871H5.15975C4.9552 12.2871 4.84384 12.5261 4.97541 12.6827L6.74582 14.7903C6.89034 14.9624 7.1709 14.8602 7.1709 14.6355V12.5278Z"
      fill="#3C3C3C"
    />
    <path
      d="M7.1709 8.73683C7.1709 8.60388 7.06312 8.49609 6.93016 8.49609H5.15975C4.9552 8.49609 4.84384 8.73505 4.97541 8.89168L6.74582 10.9993C6.89034 11.1714 7.1709 11.0692 7.1709 10.8445V8.73683Z"
      fill="#3C3C3C"
    />
    <path
      d="M7.1709 4.94387C7.1709 4.81091 7.06312 4.70312 6.93016 4.70312H5.15975C4.9552 4.70312 4.84384 4.94208 4.97541 5.09871L6.74582 7.20634C6.89034 7.37839 7.1709 7.27619 7.1709 7.0515V4.94387Z"
      fill="#3C3C3C"
    />
  </svg>
);

export default StatusActiveIcon;
